import { render, staticRenderFns } from "./multiEnum.vue?vue&type=template&id=2c6d633a&scoped=true&"
import script from "./multiEnum.vue?vue&type=script&lang=js&"
export * from "./multiEnum.vue?vue&type=script&lang=js&"
import style0 from "./multiEnum.vue?vue&type=style&index=0&id=2c6d633a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d633a",
  null
  
)

export default component.exports